import CartItems from "./cart-items"
import Feedback from "./feedback"

export const Snackbar = () => { }
Snackbar.CartItems = ( props ) => CartItems( props )
Snackbar.Feedback = ( props ) => Feedback( props )

export default Snackbar
